<div class="expansion-panel" [ngClass]="{'expanded': isExpanded}">
    <div class="expansion-panel-header" [ngClass]="isExpanded?'panel-open':'panel-close'" (click)="togglePanel()">
        <ng-content select="[panel-title]"></ng-content>
         <mat-icon>{{isExpanded?"remove":"add"}}</mat-icon>
    </div>
    <div class="expansion-panel-content" [ngClass]="{'expanded': isExpanded}">
        <ng-content select="[panel-content]"></ng-content>
    </div>
</div>